import { PortableText } from "@portabletext/react";

const components = {
  marks: {
    link: ({ value, children }) => {
      const isExternal = value?.href?.startsWith("http");
      return (
        <a
          href={value?.href}
          target={isExternal ? "_blank" : undefined}
          rel={isExternal ? "noopener noreferrer" : undefined}
          className="text-brand-primary underline hover:no-underline"
        >
          {children}
        </a>
      );
    },
  },
};

export default function RichText({ value, className = "" }) {
  return (
    <div className={className}>
      <PortableText value={value} components={components} />
    </div>
  );
}
